import { useEffect, useRef, type ElementType, type ReactNode } from 'react'
import { gsap, EASE_OUT, prefersReducedMotion } from './gsap'

/**
 * Revelação única ao entrar em vista (portado do modelo do Ângelo): sobe 12–20px e aparece, uma vez, e sai do caminho —
 * nunca acompanha o scroll depois. `stagger` anima os filhos diretos em sequência. Reduced-motion: nada anima.
 * Estado final = estado de repouso da página (o gate de reduced-motion exige nenhum texto com opacity 0 após 1 s).
 */
export function Reveal({ children, className, y = 20, stagger, as: Tag = 'div', ...rest }: { children: ReactNode; className?: string; y?: number; stagger?: number; as?: ElementType } & Record<string, unknown>) {
  const ref = useRef<HTMLElement>(null)
  useEffect(() => {
    const el = ref.current
    if (!el || prefersReducedMotion()) return
    const targets = stagger ? Array.from(el.children) : el
    const ctx = gsap.context(() => {
      gsap.set(targets, { opacity: 0, y })
      gsap.to(targets, { opacity: 1, y: 0, duration: 0.7, ease: EASE_OUT, stagger: stagger ?? 0, scrollTrigger: { trigger: el, start: 'top 88%', once: true } })
    }, el)
    return () => ctx.revert()
  }, [y, stagger])
  return <Tag ref={ref} className={className} {...rest}>{children}</Tag>
}
